import { soldProducts } from "./sold-products";
import { chipsBurned } from "./chips-burned";
import { paymentMethodReport } from "./payment-method-report";
export const barReports = {
	tabs: {
		soldProducts,
		chipsBurned,
		waiterReport: {
			label: "Ranking de Vendas",
			filter: "Filtrar por tipo de transação",
		},
		deliveredProductsByBar: {
			label: "Produtos entregues por bar",
		},
		consolidatedBarReport: {
			label: "Financeiro por bar",
			tab: "Faturamento por bar",
			filter: "Filtrar por tipo de transação",
			total: "Total",
			sheet: {
				title: "Faturamento por bar",
				fileName: "faturamento-por-bar",
				name: "Produto",
				quantity: "Quantidade",
				totalValue: "Valor bruto",
				totalDiscount: "Desconto total",
				value: "Valor líquido",
				totalTax: "Imposto Total",
				vat: {
					totalValue: "Valor com IVA",
					valueWithDiscount: "Valor com desconto",
					value: "Valor sem IVA",
					totalTax: "Valor do IVA",
					totalTaxPercentage: "Porcentagem total do IVA (%)",
				},
			},
			paymentMethodReport,
		},
		soldProductReport: {
			label: "Saída geral de produtos",
			filter: "Filtrar por tipo de transação",
			sheet: {
				title: "Saída geral de produtos",
				fileName: "relatorio_de_saida_geral_de_produtos",
				fiscalCode: "SKU",
				name: "Produto",
				count: "Quantidade",
			},
		},
		reprintReport: {
			title: "Reimpressão de fichas",
			filename: "reimpressao-de-fichas",
			byTransaction: "Por transação",
			byProduct: "Por produto",
			variable: "Variável",
			variableTooltip:
				"O valor unitário de produtos com valor variável é a média dos valores vendidos",
			table: {
				authorizedBy: "Funcionário autorizador",
				date: "Data/hora",
				employee: "Funcionário Logado",
				transactionId: "ID da transação",
				device: "Máquina",
				product: "Produto",
				total: "Total",
				reprintTotal: "Total em reimpressões",
				reprintProductTotal: "Total de produtos reimpressos",
				authorizedByPassword: "Autorizado por senha",
				quantity: "Quantidade",
				productName: "Nome do produto",
				unitValue: "Valor unitário",
				value: "Valor",
			},
			tooltipTitle:
				"Esse relatório só irá trazer dados se os PDVs estiverem na versão 5.0.190 ou superior.",
		},
	},
	bar: "Bar {{name}}",
	undefinedBar: "Bar Indefinido",
	productReturnsReport: {
		title: "Devolução de produto",
	},
};
